module.exports = __webpack_public_path__ + "img/hair-color-@2x.04bd1d85.jpg";